module.exports = __webpack_public_path__ + "img/papyrus.9e110432.png";